import {
    apiRequest,
    pensiunCreate,
    masterEmployee,
    masterType
} from "../../../../../services/adapters/kepegawaian/pensiunService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pensiunCreate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", masterEmployee, {
            params: query
        }, true)
    }

    fetchType = async (query) => {
        return await apiRequest("get", masterType, {
            params: query
        }, true)
    }

}

export default CreateRepository